/* eslint-disable react/jsx-props-no-spreading */

import {
    GridRenderCellParams,
} from '@mui/x-data-grid-pro'

import getComponentByName from 'app/utils/components/getComponentByName'
import {
    SkyDataGridColumnDefinition,
} from '../SkyBaseDataGrid.types'

export default function renderCell(column: SkyDataGridColumnDefinition<any>): {
    renderCell: (params?: Record<string, any>) => JSX.Element
} {
    let result: ((params?: GridRenderCellParams) => JSX.Element) | undefined

    if ('componentName' in column && column?.componentName) {
        result = (params: GridRenderCellParams) => {
            const {
                componentName,
                ...rest
            } = column

            const {
                value,
                row,
            } = params

            /*
            * need to reload types due to our componentName's
            * not always return JSX.Element as required
            * */
            const RenderCellComponent = getComponentByName(componentName) as unknown as
                (props: Record<string, any>) => JSX.Element

            return (
                <RenderCellComponent
                    {...rest}
                    value={value}
                    rowProps={{
                        ...row,
                    }}
                />
            )
        }
    }

    if ('renderCell' in column && column?.renderCell) result = column?.renderCell

    return {
        renderCell: result,
    }
}
